import { render, staticRenderFns } from "./BranchGrid.vue?vue&type=template&id=3bb8752e"
import script from "./BranchGrid.vue?vue&type=script&lang=js"
export * from "./BranchGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports